export default __webpack_public_path__ + "static/media/mobile1.ec8097c2.jpg";